module.exports = __webpack_public_path__ + "img/datos.bb620772.png";